export const PWA_EVENTS = {
  OFFLINE_READY: 'vylo:pwa-offline-ready',
  UPDATE_READY: 'vylo:pwa-update-ready',
};

const dispatchPwaEvent = (name, detail = {}) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
};

const registerServiceWorkerInstance = async () => {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.register(`${process.env.PUBLIC_URL || ''}/sw.js`);

    if (registration.waiting) {
      dispatchPwaEvent(PWA_EVENTS.UPDATE_READY, { registration });
    }

    registration.addEventListener('updatefound', () => {
      const installingWorker = registration.installing;
      if (!installingWorker) return;

      installingWorker.addEventListener('statechange', () => {
        if (installingWorker.state !== 'installed') return;

        if (navigator.serviceWorker.controller) {
          dispatchPwaEvent(PWA_EVENTS.UPDATE_READY, { registration });
          return;
        }

        dispatchPwaEvent(PWA_EVENTS.OFFLINE_READY, { registration });
      });
    });
  } catch (error) {
    // Keep registration failures non-fatal. The mobile web should still boot normally.
    console.error('[pwa] service worker registration failed', error);
  }
};

export const registerPwaServiceWorker = () => {
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

  if (document.readyState === 'complete') {
    void registerServiceWorkerInstance();
    return;
  }

  window.addEventListener('load', () => {
    void registerServiceWorkerInstance();
  }, { once: true });
};

export const applyPwaUpdate = async (registration) => {
  if (!registration?.waiting) return false;
  registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  return true;
};
